import { render } from "./ContentView.vue?vue&type=template&id=49af1bfd"
import script from "./ContentView.vue?vue&type=script&lang=js"
export * from "./ContentView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__